import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import io from 'socket.io-client';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AnnouncementService from '../admin/announcement/AnnouncementService';
import CaseTicketService from '../caseTicket/CaseTicketService';
import MercariService from '../mercari/mercariService';
import ChatFeedbackService from '../chatFeedback/ChatFeedbackService';
import ChatFeedbackDrawer from '../chatFeedback/ChatFeedbackDrawer';
import { fmtDue } from '../chatFeedback/chatFeedbackShared';
import OrderService from '../order/OrderService';
import AirItemTypeService from '../../services/AirItemTypeService';
import Modal from 'react-modal';
import AddEditForm from '../../sharedComponents/AddEditForm';
import ShipDatePayment from '../../sharedComponents/ShipDatePayment';
import NewOrderList from './pendingPayment/NewOrderList';
import OrderForm from './OrderForm';
import useGetCustomerProfile from '../../hooks/useGetCustomerProfile';
import useCustomerProfile from '../customerProfile/useCustomerProfile';

import GetCustomerProfileService from '../../services/GetCustomerProfileService';
import OrderAmount from './OrderAmount';
import useManageOrder from '../order/useManageOrder';
import { useDispatch, useSelector } from 'react-redux';
import { selectAmountCalIsOpen, selectOrderDetailIsOpen, selectProfileIsOpen, setAmountCalIsOpen, setShipDatePaymentIsOpen, setKeyDataPendingOrders, setOrderDetailIsOpen, setProfileIsOpen, selectShipDatePaymentIsOpen, setKeyDataContact } from '../../redux/features/keyDataSlice';
import OrderDetailList from './pendingPayment/OrderDetailList';
import AmountCal from './modalMenu/amountCal/AmountCal';
import ProductPaid from './ProductPaid';
import { addProfileToState } from '../../redux/features/customerProfileSlice';
import { useAuth } from '../../context/AuthContext'
import Translate from './modalMenu/translate/Translate';
import BlacklistOrders from './modalMenu/BlacklistOrders';
import { selectRateByShop } from '../../redux/features/todayRateSlice';
import AuctionCalculator from './modalMenu/AuctionCalculator';
import AirItemPriceModal from './modalMenu/AirItemPriceModal';
import { formatAmountRound } from '../../utils/formatAmount';
import { generateBlacklistWarningMessage, getShopDisplayName } from '../../utils/shopNameMapping';
import BlacklistWarningModal from '../../sharedComponents/BlacklistWarningModal';
import ClaimBanner from './ClaimBanner';

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)' // This sets the overlay color
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '500px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const customStylesOrderDetail = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)', // This sets the overlay color
    zIndex: 1000
  },
  content: {
    top: '50%',
    left: '55%',
    right: 'auto',
    bottom: 'auto',
    height: '800px',
    width: '1300px',
    marginRight: '0%',
    transform: 'translate(-50%, -50%)',
  },
};

const items = [
  {
    title: 'Facebook/Line',
    name: 'contact',
    type: 'text',
  },
  {
    title: 'Smile Name',
    name: 'smileName',
    type: 'text',
  },
  {
    title: 'Smile Name Jp',
    name: 'smileNameJp',
    type: 'text',
  },
  {
    title: 'Phone',
    name: 'phone',
    type: 'text',
  },
  {
    title: 'ชื่อ-นามสกุล ลูกค้า (ไทย/อังกฤษ ก็ได้) ถ้าไม่รู้เว้นว่างไว้',
    name: 'customerName',
    type: 'text',
  },
  {
    title: 'Channel',
    name: 'channel',
    type: 'select',
    options:[{
      label: 'Facebook',
      value: 'Facebook'
    },{
      label: 'Line',
      value: 'Line'
    }]
  },
];

const initialValue = {
  contact: '',
  smileName: '',
  smileNameJp: '',
  productRate: '',
  customerName: '',
}
const KeyData = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [newProfile, setNewProfile] = useState({});
  const [registerIsOpen, setRegisterIsOpen] = useState(false)
  const [unreadAnnouncementCount, setUnreadAnnouncementCount] = useState(0);
  // Chat-quality feedback waiting for this admin: { pending, discussing, overdue, nextDueAt }
  const [chatFeedback, setChatFeedback] = useState({ pending: 0, discussing: 0, overdue: 0, nextDueAt: null });
  const [chatFeedbackOpen, setChatFeedbackOpen] = useState(false);
  const [unclaimedBeamCount, setUnclaimedBeamCount] = useState(0);
  const [myPendingBeamCount, setMyPendingBeamCount] = useState(0);
  const [unclaimedReceiptCount, setUnclaimedReceiptCount] = useState(0);
  const [myReceiptCount, setMyReceiptCount] = useState(0);
  const [wonAuctionCount, setWonAuctionCount] = useState(0);
  const [unclaimedCancelCount, setUnclaimedCancelCount] = useState(0);
  const [myCancelCount, setMyCancelCount] = useState(0);
  const [voidNotifyCount, setVoidNotifyCount] = useState(0);
  const [unclaimedCaseCount, setUnclaimedCaseCount] = useState(0);
  const [myCaseCount, setMyCaseCount] = useState(0);
  const [unclaimedMercariAdminCount, setUnclaimedMercariAdminCount] = useState(0);
  const [myMercariAdminCount, setMyMercariAdminCount] = useState(0);
  const [unclaimedChangeCount, setUnclaimedChangeCount] = useState(0);
  const [myChangeCount, setMyChangeCount] = useState(0);
  const [blacklistIsOpen, setBlacklistIsOpen] = useState(false)
  const [defaultProfile, setDefaultProfile] = useState({});
  const [saveCount, setSaveCount] = useState(0);
  const [translateIsOpen, setTranslateIsOpen] = useState(false)
  const [shipDatePaymentSmileName, setShipDatePaymentSmileName] = useState('');
  const profileIsOpen = useSelector(selectProfileIsOpen)
  const orderDetailIsOpen = useSelector(selectOrderDetailIsOpen)
  const amountCalIsOpen = useSelector(selectAmountCalIsOpen)
  const shipDatePaymentIsOpen = useSelector(selectShipDatePaymentIsOpen)
  const [auctionCalculatorIsOpen, setAuctionCalculatorIsOpen] = useState(false)
  const [airItemPriceModalIsOpen, setAirItemPriceModalIsOpen] = useState(false)
  const [airItemTypesFull, setAirItemTypesFull] = useState([]);
  const [blacklistWarningQueue, setBlacklistWarningQueue] = useState([]);
  const [currentBlacklistWarning, setCurrentBlacklistWarning] = useState(null);
  const [sameContactWarningMessage, setSameContactWarningMessage] = useState(null);

  // Load air item types once for OrderForm and AirItemPriceModal
  useEffect(() => {
    let mounted = true;
    AirItemTypeService.getAirItemTypes()
      .then((res) => {
        if (mounted && res?.data?.data) setAirItemTypesFull(res.data.data);
      })
      .catch(() => { if (mounted) setAirItemTypesFull([]); });
    return () => { mounted = false; };
  }, []);

  const handleCloseBlacklistWarning = () => {
    setBlacklistWarningQueue(prev => {
      const remaining = prev.slice(1);
      if (remaining.length > 0) {
        setCurrentBlacklistWarning(remaining[0]);
      } else {
        setCurrentBlacklistWarning(null);
      }
      return remaining;
    });
  };

  const handleCloseSameContactWarning = () => {
    setSameContactWarningMessage(null);
  };

  const { authState } = useAuth();
  const { user } = authState;

  const {
    orderGroup,
    getPendingOrder
  } = useManageOrder()

  const {
    profile,
    loading,
    error,
    setProfile,
    getDefaultProfile,
    getProfileFromContact
  } = useGetCustomerProfile();

  const {
    addCustomerProfile,
    isLoading: isCustomerProfileLoading
  } = useCustomerProfile();
  const registerSubmittingRef = useRef(false);

  const shopName = useSelector((state) => state.shop.name);
  const todayRate = useSelector(state => selectRateByShop(state, shopName));

  const fetchDefaultProfile = async () => {
    try {
      // Call the service directly instead of using the hook's method
      // This prevents the hook's profile state from being updated, which would affect OrderForm
      const response = await GetCustomerProfileService.getDefaultProfile(shopName);
      const fetchedProfile = response.data;
      
      // Use fetched data only for modal's newProfile state
      // This does NOT affect the main profile state used by OrderForm  
      setNewProfile({
        ...fetchedProfile,
        contact: '',
        smileName: '',
        smileNameJp: '',
        channel: '',
      });
      setDefaultProfile(fetchedProfile)
    } catch (error) {
      console.error("Failed to fetch default profile:", error);
    }
  };

  const refreshPendingOrder = () => {
    setSaveCount(prevCount => prevCount + 1)
  }

  const handleNewProfileChange = (e) => {
    const {name, value} = e.target
    // Trim contact and phone fields
    let trimmedValue = value;
    if (name === 'contact' || name === 'phone') {
      trimmedValue = value.trim();
    }
    setNewProfile(prevState => ({
        ...prevState,
        [name]: trimmedValue
    }));
  };

  const handleRegisterCustomerProfile = async () => {
    if (registerSubmittingRef.current) return;
    registerSubmittingRef.current = true;
    try {
      // Trim contact and phone before sending to backend
      const trimmedProfile = {
        ...newProfile,
        contact: newProfile.contact ? newProfile.contact.trim() : newProfile.contact,
        phone: newProfile.phone ? newProfile.phone.trim() : newProfile.phone
      };
      const registerdResult = await addCustomerProfile(trimmedProfile);
      if (registerdResult === true) {
        // Fetch the newly registered profile using the trimmed contact
        const registeredProfile = await getProfileFromContact(trimmedProfile.contact);
        if (registeredProfile) {
          // Calculate the correct product rate based on profile settings
          let updatedProfile = { ...registeredProfile };
          
          if (registeredProfile.isFlowRate) {
            const newRate = todayRate - (registeredProfile.extraFlowDiscount || 0);
            updatedProfile.productRate = Math.round(newRate * 10000) / 10000;
          }

          setProfile(updatedProfile);
          toast.success("Register new customer successful!!");
          dispatch(setProfileIsOpen(false));
          dispatch(addProfileToState(updatedProfile));
                    
          // Check if blacklisted in other shops (higher priority)
          if (registeredProfile.isBlacklistedInOtherShops && registeredProfile.blacklistedShops && registeredProfile.blacklistedShops.length > 0) {
            const warningMessages = registeredProfile.blacklistedShops.map(blacklistedShop => {
              const formattedAmount = formatAmountRound(blacklistedShop.totalPendingAmount);
              return generateBlacklistWarningMessage(blacklistedShop.shop, formattedAmount, blacklistedShop.source);
            });
            setBlacklistWarningQueue(warningMessages);
            if (warningMessages.length > 0) {
              setCurrentBlacklistWarning(warningMessages[0]);
            }
            // Clear same contact warning if blacklist warning exists
            setSameContactWarningMessage(null);
          } else {
            // Check if has same contact in other shops (only if not blacklisted)
            // Only show warning for first order (smileOrderNo === 0)
            if (registeredProfile.hasSameContactInOtherShops && registeredProfile.smileOrderNo === 0) {
              // Get the other shop name (opposite of current shop)
              const otherShop = shopName === 'smile' ? 'tama' : 'smile';
              const otherShopDisplayName = getShopDisplayName(otherShop);
              setSameContactWarningMessage(`กรุณาไปตรวจสอบที่ ${otherShopDisplayName} ว่าเป็นคนเดียวกันไหม ถ้าคนละคน กดได้ แต่ถ้า คนเดียวกันห้ามกด`);
            } else {
              setSameContactWarningMessage(null);
            }
          }
        } else {
          toast.error("Failed to fetch newly registered profile");
        }
      } else {
        if (registerdResult === 'Smile Name Duplicate') {
          toast.error('ชื่อ สมาย ซ้ำกับคนอื่น');
        } else {
          toast.error(registerdResult);
        }
      }
    } catch (error) {
      console.error("Error during registration:", error);
      toast.error("Registration failed");
    } finally {
      registerSubmittingRef.current = false;
    }
  };
  
  // orders_updated reaches every admin tab at the same instant on each order
  // create/edit/payment, and the unpaid list is several MB. Reloading it everywhere
  // at once piled up on the server and slowed saving, so a tab reloads at most once,
  // after a staggered delay, only while visible, and not at all if a reload already
  // started after the event (the admin who saved reloads via saveCount).
  const lastPendingFetchRef = useRef(0);
  const pendingStaleAtRef = useRef(0); // newest unloaded orders_updated; 0 = up to date
  const pendingReloadTimerRef = useRef(null);

  const loadPendingOrders = () => {
    lastPendingFetchRef.current = Date.now();
    return getPendingOrder();
  };
  // The socket listener and 5-minute timer are set up once on mount; calling through
  // this ref makes them load the current shop, not the one at mount (on a first
  // login the shop arrives from /api/user/getshop after KeyData has mounted).
  const loadPendingOrdersRef = useRef(loadPendingOrders);
  loadPendingOrdersRef.current = loadPendingOrders;

  const reloadPendingIfStale = () => {
    pendingReloadTimerRef.current = null;
    const staleAt = pendingStaleAtRef.current;
    if (!staleAt) return;
    // 1.5s slack: the saver's own reload can start just before its socket event lands.
    if (lastPendingFetchRef.current >= staleAt - 1500) { pendingStaleAtRef.current = 0; return; }
    if (document.hidden) return; // the visibilitychange listener reloads on return
    pendingStaleAtRef.current = 0;
    loadPendingOrdersRef.current();
  };

  useEffect(() => {
    const fetchOrders = async () => {
      await loadPendingOrders();
    };
    fetchOrders();
  }, [saveCount, shopName]); // eslint-disable-line react-hooks/exhaustive-deps

  // Add 5-minute refresh effect
  useEffect(() => {
    const interval = setInterval(() => {
      loadPendingOrdersRef.current(); // Refresh pending orders every 5 minutes
    }, 5 * 60 * 1000); // 5 minutes

    return () => clearInterval(interval);
  }, []); // Empty dependency array - runs once on mount

  function handleOrderFormAction(){
    setSaveCount(prevCount => prevCount + 1)
    dispatch(setKeyDataPendingOrders([]))
  }

  // After "เก็บเงิน" the customer is done: refresh รายการรอจ่าย and empty the form's contact.
  function handleWalletCharged(){
    handleOrderFormAction()
    dispatch(setKeyDataContact(""))
  }

  const openNewCustomerForm = async () => {
    setRegisterIsOpen(true)
    await fetchDefaultProfile();
  };

  const closeNewCustomerForm = () =>{
    setProfile({})
    setRegisterIsOpen(false)
    dispatch(setProfileIsOpen(false))
  }

  const openAuctionCalculatorForm = async () => {
    await fetchDefaultProfile();
    setAuctionCalculatorIsOpen(true)
  }

  const closeAuctionCalculatorForm = () =>{
    setAuctionCalculatorIsOpen(false)
  }

  const openAirItemPriceModal = () => setAirItemPriceModalIsOpen(true)
  const closeAirItemPriceModal = () => setAirItemPriceModalIsOpen(false)
  
  const openAmountCalForm = async () => {
    await fetchDefaultProfile();
    dispatch(setAmountCalIsOpen(true))
  };
  
  const closeAmountCalForm = () =>{
    dispatch(setAmountCalIsOpen(false))
  }

  const openTranslateModal = async () => {
    setTranslateIsOpen(true)
  };
  
  const closeTranslateModal = () =>{
    setTranslateIsOpen(false)
  }
  
  const openBlacklistModal = async () => {
    setBlacklistIsOpen(true)
  };

  const closeBlacklistModal = () =>{
    setBlacklistIsOpen(false)
  }

  const openShipDatePayment = async () => {
    dispatch(setShipDatePaymentIsOpen(true))
  };
  
  const closeShipDatePayment = () =>{
    dispatch(setShipDatePaymentIsOpen(false))
  }

  useEffect(() => {
		toast.error(error)
	},[error])

  useEffect(() => {
    if(registerIsOpen){
      dispatch(setProfileIsOpen(true))
    }
  }, [newProfile])

  // Reset globalProfile (contact) when entering the page
  useEffect(() => {
    // Reset the global contact to empty string (data0 state)
    dispatch(setKeyDataContact(""));
  }, []); // Empty dependency array means this runs only once when component mounts

  // Chat-quality feedback waiting for this admin (รับทราบ + คำตอบ). Refetched on
  // the case_claim_updated socket ('chat_feedback') so a case the supervisor
  // just sent shows up without reloading — same route the ต่อราคา banners use.
  const fetchChatFeedbackCount = () => {
    ChatFeedbackService.getUnreadCount()
      .then(res => setChatFeedback({
        pending: res.data?.pending || 0,
        discussing: res.data?.discussing || 0,
        overdue: res.data?.overdue || 0,
        nextDueAt: res.data?.nextDueAt || null
      }))
      .catch(() => {});
  };

  useEffect(() => {
    let mounted = true;
    AnnouncementService.getUnreadCount()
      .then(res => { if (mounted) setUnreadAnnouncementCount(res.data?.unreadCount || 0); })
      .catch(() => {});
    fetchChatFeedbackCount();
    return () => { mounted = false; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchBeamCounts = () => {
    if (!shopName) return;
    OrderService.getPendingBeamClaimCounts(shopName)
      .then(res => {
        setUnclaimedBeamCount(res.data?.unclaimedCount || 0);
        setMyPendingBeamCount(res.data?.myPendingCount || 0);
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchBeamCounts();
  }, [shopName]);

  // Won Mercari auctions nobody has taken yet (set by the auction poller,
  // claimed cases drop out — someone is already buying those). Refreshed via the
  // case_claim_updated socket: the poller emits 'auction_won' on a new win, and
  // claim/release emit it too.
  const fetchWonAuctions = () => {
    if (!shopName) return;
    MercariService.getAuctionAttentionItems(shopName)
      .then(res => setWonAuctionCount(res.data?.unclaimedCount || 0))
      .catch(() => {});
  };

  useEffect(() => {
    fetchWonAuctions();
  }, [shopName]); // eslint-disable-line react-hooks/exhaustive-deps

  // Mercari item price/comment changes (the /mercarichange cases, also sent to
  // Discord). Refreshed via the case_claim_updated socket: the poller emits it
  // when it creates changes, and take/complete emit it too.
  const fetchMercariChangeCounts = () => {
    if (!shopName) return;
    MercariService.getMercariChangeClaimCounts(shopName)
      .then(res => {
        setUnclaimedChangeCount(res.data?.unclaimedCount || 0);
        setMyChangeCount(res.data?.myPendingCount || 0);
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchMercariChangeCounts();
  }, [shopName]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchReceiptCounts = () => {
    if (!shopName) return;
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/money/refund/pending-receipt-counts`, { shop: shopName }, { withCredentials: true })
      .then(res => {
        setUnclaimedReceiptCount(res.data?.unclaimedCount || 0);
        setMyReceiptCount(res.data?.myCount || 0);
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchReceiptCounts();
  }, [shopName]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchCancelCounts = () => {
    if (!shopName) return;
    OrderService.getCancelClaimCounts(shopName)
      .then(res => {
        setUnclaimedCancelCount(res.data?.unclaimedCount || 0);
        setMyCancelCount(res.data?.myCount || 0);
        setVoidNotifyCount(res.data?.voidNotifyCount || 0);
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchCancelCounts();
  }, [shopName]); // eslint-disable-line react-hooks/exhaustive-deps

  // Case-ticket banners, strictly action-required-now (see backend
  // isAdminActionable): unclaimed = nobody took it yet, in the selected shop;
  // my = cases I claimed that need me again, in any shop (only I see).
  const fetchCaseTicketCounts = () => {
    CaseTicketService.getActionableCounts(shopName)
      .then(res => {
        setUnclaimedCaseCount(res.data?.unclaimedActionable || 0);
        setMyCaseCount(res.data?.myActionable || 0);
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchCaseTicketCounts();
  }, [shopName]); // eslint-disable-line react-hooks/exhaustive-deps

  // Mercari-admin queue (purchase + price-negotiation + receipt-approval), all
  // claimed through the central case_claims table. Scoped to the currently
  // selected shop (like the beam / receipt / cancel banners): re-fetches on
  // shop switch and on the case_claim_updated socket for its caseTypes.
  const fetchMercariAdminCounts = () => {
    if (!shopName) return;
    MercariService.getMercariAdminClaimCounts(shopName)
      .then(res => {
        setUnclaimedMercariAdminCount(res.data?.unclaimedCount || 0);
        setMyMercariAdminCount(res.data?.myCount || 0);
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchMercariAdminCounts();
  }, [shopName]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const socket = io(`${process.env.REACT_APP_BACKEND_URL}/admin-dashboard`, {
      withCredentials: true
    });

    socket.on('new_case_ticket', () => fetchCaseTicketCounts());
    socket.on('case_ticket_updated', () => fetchCaseTicketCounts());

    socket.on('orders_updated', () => {
      pendingStaleAtRef.current = Date.now();
      if (!pendingReloadTimerRef.current) {
        pendingReloadTimerRef.current = setTimeout(reloadPendingIfStale, 3000 + Math.random() * 4000);
      }
      fetchBeamCounts();
    });
    const onVisible = () => { if (!document.hidden) reloadPendingIfStale(); };
    document.addEventListener('visibilitychange', onVisible);

    socket.on('new_announcement', () => {
      setUnreadAnnouncementCount(prev => prev + 1);
    });

    socket.on('refund_slip_uploaded', () => {
      fetchReceiptCounts();
    });

    // Generic case-claim event (refund + cancel + beam + case tickets on the
    // central case_claims table); switch on caseType so one listener covers
    // every case kind.
    socket.on('case_claim_updated', ({ caseType } = {}) => {
      if (caseType === 'refund') fetchReceiptCounts();
      // "ยกเลิก Beam" moves an order out of the pending-Beam count too, but only
      // announces 'cancel' - refresh both so that banner is not left stale (QA 730).
      else if (caseType === 'cancel') { fetchCancelCounts(); fetchBeamCounts(); }
      else if (caseType === 'pending_beam') fetchBeamCounts();
      else if (caseType === 'case_ticket') fetchCaseTicketCounts();
      // Every case type the Mercari-admin banner counts. The backend totals all
      // five in one number, so missing one here leaves the banner stale until the
      // next poll — it must list exactly what getMercariAdminClaimCounts sums.
      else if (
        caseType === 'mercari_purchase' ||
        caseType === 'mercari_price_negotiation' ||
        caseType === 'marketplace_price_negotiation' ||
        caseType === 'custom_purchase' ||
        caseType === 'mercari_appraisal' ||
        caseType === 'dispatch' // Mercari dispatch-bot tasks (FujiKing / ask a buyer / sold…)
      ) fetchMercariAdminCounts();
      else if (caseType === 'mercari_change') fetchMercariChangeCounts();
      else if (caseType === 'auction_won') fetchWonAuctions();
      else if (caseType === 'chat_feedback') fetchChatFeedbackCount();
    });

    // A NEW customer purchase / price request is announced only on the buy board's
    // namespace, never as case_claim_updated, so the "Mercari รอดำเนินการ" banner did
    // not move until the next poll (QA 730). Listen there too.
    const mercariAdmin = io(`${process.env.REACT_APP_BACKEND_URL}/mercari-admin`, {
      withCredentials: true
    });
    mercariAdmin.on('new_purchase_request', () => fetchMercariAdminCounts());
    mercariAdmin.on('new_negotiation_request', () => fetchMercariAdminCounts());

    return () => {
      socket.disconnect();
      mercariAdmin.disconnect();
      document.removeEventListener('visibilitychange', onVisible);
      clearTimeout(pendingReloadTimerRef.current);
    };
  }, []);

  return (
    <div>
        <ClaimBanner
          count={unreadAnnouncementCount}
          tone="amber"
          title={`⚠️ มีประกาศใหม่ที่ยังไม่ได้อ่าน ${unreadAnnouncementCount} รายการ`}
          subtitle="กรุณาอ่านและรับทราบประกาศก่อนดำเนินการต่อ"
          cta="ดูประกาศ →"
          onClick={() => navigate('/notifications')}
        />
        <ClaimBanner
          count={chatFeedback.pending + chatFeedback.discussing}
          tone={chatFeedback.overdue > 0 ? 'red' : 'purple'}
          title={`📋 Feedback แชท ${chatFeedback.pending + chatFeedback.discussing} เคส${chatFeedback.pending > 0 && chatFeedback.nextDueAt ? ` · ต้องรับทราบก่อน ${fmtDue(chatFeedback.nextDueAt)}` : ''}`}
          subtitle={chatFeedback.overdue > 0
            ? `เลยกำหนดรับทราบแล้ว ${chatFeedback.overdue} เคส กรุณาอ่านก่อน`
            : chatFeedback.discussing > 0
              ? `หัวหน้าตอบกลับมา ${chatFeedback.discussing} เคส`
              : 'เปิดอ่านตรงนี้ได้เลย ออเดอร์ที่พิมพ์ค้างไว้ไม่หาย'}
          cta="เปิดอ่าน →"
          onClick={() => setChatFeedbackOpen(true)}
        />
        <ChatFeedbackDrawer
          open={chatFeedbackOpen}
          onClose={() => { setChatFeedbackOpen(false); fetchChatFeedbackCount(); }}
          onChanged={fetchChatFeedbackCount}
        />
        <ClaimBanner
          count={wonAuctionCount}
          tone="redDark"
          title={`🔨 ประมูล Mercari ชนะแล้ว — รอกดซื้อ ${wonAuctionCount} รายการ`}
          subtitle="ต้องกดซื้อภายใน 24 ชม. หลังชนะ — เกินกำหนดเสี่ยงโดนแบน"
          cta="ไปจัดการ →"
          onClick={() => navigate('/neworder')}
        />
        <ClaimBanner
          count={unclaimedCancelCount}
          tone="orange"
          title={`🛒 มีรายการยกเลิกรอดำเนินการ ${unclaimedCancelCount} ราย`}
          subtitle="ยังไม่มีใครรับเคส กดเพื่อไปดำเนินการ"
          cta="ดูรายการ →"
          onClick={() => navigate('/refund', { state: { tab: 'cancel' } })}
        />
        <ClaimBanner
          count={unclaimedCaseCount}
          tone="violet"
          title={`📋 มีเคสรอดำเนินการ ${unclaimedCaseCount} เคส — ยังไม่มีใครรับ`}
          subtitle="กดเพื่อไปรับเคส (เปิดเคส = รับเคสอัตโนมัติ)"
          cta="ดูรายการ →"
          onClick={() => navigate('/case-ticket')}
        />
        <ClaimBanner
          count={myCaseCount}
          tone="green"
          title={`✋ เคสที่คุณรับไว้ต้องดำเนินการต่อ ${myCaseCount} เคส`}
          subtitle="หัวหน้าตอบแล้ว / ถึงเวลาดำเนินการต่อ — กดเพื่อไปทำต่อ"
          cta="ดูรายการ →"
          onClick={() => navigate('/case-ticket')}
        />
        <ClaimBanner
          count={unclaimedMercariAdminCount}
          tone="indigo"
          title={`🛍️ มีเคส Mercari รอดำเนินการ ${unclaimedMercariAdminCount} รายการ`}
          subtitle="สั่งซื้อ / ต่อราคา / ตรวจสลิป / งานกดบอท — ยังไม่มีใครรับเคส กดเพื่อไปดำเนินการ"
          cta="ดูรายการ →"
          onClick={() => navigate('/mercariadmin')}
        />
        <ClaimBanner
          count={myMercariAdminCount}
          tone="red"
          title={`⚠️ คุณมีเคส Mercari ที่ยังไม่เสร็จ ${myMercariAdminCount} รายการ`}
          subtitle="กรุณากลับไปดำเนินการให้เสร็จ"
          cta="ไปดำเนินการ →"
          onClick={() => navigate('/mercariadmin')}
        />
        <ClaimBanner
          count={myCancelCount}
          tone="red"
          title={`⚠️ คุณมีเคสยกเลิกที่ยังไม่เสร็จ ${myCancelCount} ราย`}
          subtitle="กรุณากลับไปดำเนินการให้เสร็จ"
          cta="ดูรายการ →"
          onClick={() => navigate('/refund', { state: { tab: 'cancel' } })}
        />
        <ClaimBanner
          count={voidNotifyCount}
          tone="green"
          title={`✅ Void แล้ว — รอแจ้งลูกค้า ${voidNotifyCount} ราย`}
          subtitle="เงินคืนเข้าบัตรแล้ว กดเพื่อไปแจ้งลูกค้า"
          cta="ดูรายการ →"
          onClick={() => navigate('/refund', { state: { tab: 'cancel' } })}
        />
        <ClaimBanner
          count={unclaimedReceiptCount}
          tone="blue"
          title={`🧾 มีสลิป รอแจ้งโอนคืนลูกค้า ${unclaimedReceiptCount} รายการ`}
          subtitle="ยังไม่มีใครรับเคส กดเพื่อไปดำเนินการ"
          cta="ดูรายการ →"
          onClick={() => navigate('/refund', { state: { tab: 'transferred' } })}
        />
        <ClaimBanner
          count={myReceiptCount}
          tone="red"
          title={`⚠️ คุณมีเคสแจ้งลูกค้าที่ยังไม่เสร็จ ${myReceiptCount} รายการ`}
          subtitle="กรุณากลับไปดำเนินการให้เสร็จ"
          cta="ไปดำเนินการ →"
          onClick={() => navigate('/refund', { state: { tab: 'transferred' } })}
        />
        <ClaimBanner
          count={unclaimedBeamCount}
          tone="blue"
          title={`📦 มีรายการรอสั่งซื้อ ${unclaimedBeamCount} รายการ`}
          subtitle="ยังไม่มีใครรับเคส กดเพื่อไปดำเนินการ"
          cta="ไปสั่งซื้อ →"
          onClick={() => navigate('/neworder')}
        />
        <ClaimBanner
          count={myPendingBeamCount}
          tone="red"
          title={`⚠️ คุณมีเคสที่ยังทำไม่เสร็จ ${myPendingBeamCount} รายการ`}
          subtitle="กรุณากลับไปดำเนินการให้เสร็จ"
          cta="ทำต่อ →"
          onClick={() => navigate('/neworder')}
        />
        <ClaimBanner
          count={unclaimedChangeCount}
          tone="blue"
          title={`🔔 มีการเปลี่ยนแปลงสินค้า Mercari ${unclaimedChangeCount} รายการ`}
          subtitle="ยังไม่มีใครรับเคส กดเพื่อไปดำเนินการ"
          cta="ไปดูการเปลี่ยนแปลง →"
          onClick={() => navigate('/mercarichange')}
        />
        <ClaimBanner
          count={myChangeCount}
          tone="red"
          title={`⚠️ คุณมีเคสการเปลี่ยนแปลง Mercari ที่ยังไม่เสร็จ ${myChangeCount} รายการ`}
          subtitle="กรุณากลับไปดำเนินการให้เสร็จ"
          cta="ทำต่อ →"
          onClick={() => navigate('/mercarichange')}
        />
        <div className='border-b flex mb-5 pb-2'>
          {/* <h2 className='text-4xl mb-4'>กรอกข้อมูลลูกค้า</h2> */}
          <div className='my-auto ml-auto'>
            {profile && profile.Blacklists && profile.Blacklists.length > 0 && <button
                onClick={openBlacklistModal}
                className="mr-5 w-48 rounded-md bg-red-500 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                >
                ยอดขั้นต่ำก่อนสั่งซื้อ
            </button>}
            <button
                onClick={openTranslateModal}
                className="mr-5 w-48 rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                >
                แปลภาษา
            </button>
            <button
                onClick={openAuctionCalculatorForm}
                className="mr-5 w-48 rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                >
                คำนวนยอด ประมูล
            </button>
            <button
                onClick={openAirItemPriceModal}
                className="mr-5 w-48 rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                >
                Air Item Rate
            </button>
            <button
                onClick={openAmountCalForm}
                className="mr-5 w-48 rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                >
                คำนวนยอด ก่อนสั่งซื้อ
            </button>
            <button
                onClick={openNewCustomerForm}
                className="w-48 rounded-md bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                >
                Register New Customer
            </button>
          </div>
        </div>
        <Modal
          isOpen={translateIsOpen}
          onRequestClose={closeTranslateModal}
          style={customStylesOrderDetail}
          ariaHideApp={false}
        >
          <Translate/>
        </Modal>
        <Modal
          isOpen={blacklistIsOpen}
          onRequestClose={closeBlacklistModal}
          style={customStylesOrderDetail}
          ariaHideApp={false}
        >
          <BlacklistOrders profile={profile} user={user}/>
        </Modal>
        <Modal
          isOpen={amountCalIsOpen}
          onRequestClose={() => {}} // Prevent closing on outside click
          style={customStylesOrderDetail}
          ariaHideApp={false}
          shouldCloseOnOverlayClick={false}
        >
          <AmountCal defaultProfile={defaultProfile} user={user} onClose={closeAmountCalForm}/>
        </Modal>
        <Modal
          isOpen={auctionCalculatorIsOpen}
          onRequestClose={closeAuctionCalculatorForm}
          style={customStylesOrderDetail}
          ariaHideApp={false}
        >
          <AuctionCalculator defaultProfile={defaultProfile}/>
        </Modal>
        <Modal
          isOpen={airItemPriceModalIsOpen}
          onRequestClose={closeAirItemPriceModal}
          style={customStylesOrderDetail}
          ariaHideApp={false}
        >
          <AirItemPriceModal onClose={closeAirItemPriceModal} airItemTypesList={airItemTypesFull} />
        </Modal>
        <Modal
          isOpen={profileIsOpen}
          onRequestClose={closeNewCustomerForm}
          style={customStyles}
          ariaHideApp={false}
        >
          <AddEditForm 
            items={items} 
            name='Register New Customer Profile' 
            mode='register'
            closeForm={closeNewCustomerForm}
            data={newProfile}
            handleInputChange={handleNewProfileChange}
            handleRegister={handleRegisterCustomerProfile}
            stateValue={newProfile}
            submitting={isCustomerProfileLoading}
          />
        </Modal>
        <Modal
          isOpen={orderDetailIsOpen}
          onRequestClose={()=>dispatch(setOrderDetailIsOpen(false))}
          style={customStylesOrderDetail}
          ariaHideApp={false}
        >
          <OrderDetailList 
            orderGroup={orderGroup}
            refreshPendingOrder={getPendingOrder}
            onClose={() => dispatch(setOrderDetailIsOpen(false))}
          />
        </Modal>
        <Modal
          isOpen={shipDatePaymentIsOpen}
          onRequestClose={() => {}} // Prevent closing on outside click
          style={customStylesOrderDetail}
          ariaHideApp={false}
          shouldCloseOnOverlayClick={false}
        >
          <ShipDatePayment 
            smileName={shipDatePaymentSmileName}
            refreshPendingOrder={refreshPendingOrder}
            profileState={profile}
            onClose={closeShipDatePayment}
          />
        </Modal>

        {/* Blacklist Warning Modal */}
        <BlacklistWarningModal
          isOpen={currentBlacklistWarning !== null}
          onClose={handleCloseBlacklistWarning}
          message={currentBlacklistWarning}
        />

        {/* Same Contact Warning Modal */}
        <BlacklistWarningModal
          isOpen={sameContactWarningMessage !== null}
          onClose={handleCloseSameContactWarning}
          message={sameContactWarningMessage}
        />

        <OrderForm
          profile={profile}
          setProfile={setProfile}
          getProfileFromContact={getProfileFromContact}
          onActionComplete={handleOrderFormAction}
        />
        <div className="grid grid-cols-3 gap-4 h-80% mt-3">
        <div className="col-span-1 bg-gray-200 px-6 py-4 overflow-y-auto max-h-full">
          <NewOrderList orderGroup={orderGroup}/>
        </div>
        <div className="col-span-1 bg-gray-100 p-6 overflow-y-auto max-h-full"> 
          <OrderAmount user={user} onWalletCharged={handleWalletCharged}/>
        </div> 
        <div className="col-span-1 bg-gray-100 p-6 overflow-y-auto max-h-full"> 
          <ProductPaid openCustomPayment={openShipDatePayment} setShipDatePaymentSmileName={setShipDatePaymentSmileName} refreshPendingOrder={refreshPendingOrder}/>
        </div> 
      </div>
    </div>
  )
}

export default KeyData

